<template>
  <div>
    <AiHead></AiHead>
    <el-form class="login" :model="userInfo">
      <div class="login__prompt">
        <!-- <p style="font-size:28px; font-weight: 700; margin: 0;">欢迎登录 AIGenAI 平台</p> -->
        <p style="font-size:28px; font-weight: 700; margin: 0;">欢迎访问 AIGenAI 平台</p>
        <p style="font-size:16px; margin-bottom: 50px;">人人都有专属的AGI</p>
      </div>
      <!-- <div class="login__input">
        <el-input v-model="userInfo.userName" placeholder="请输入用户名" />
      </div>
      <div class="login__password">
        <el-input v-model="userInfo.password" placeholder="请输入密码" show-password/>
      </div>
      <div class="login__checkbox">
        <el-checkbox style="margin-right: 10px;" v-model="userInfo.checked"/>
          阅读并同意《
          <router-link to="/aigenai/doc/policy/agreement.html" target="_blank" style="color: #0000ff;">用户协议</router-link>
          》和《
          <router-link to="/aigenai/doc/policy/privacy.html" target="_blank" style="color: #0000ff;">隐私政策</router-link>
          》
        </el-checkbox>
      </div> -->
      <!-- <div class="login__button" v-loading="loading"> -->
      <!-- <div class="login__button">
        <el-button id="el-button" :loading="loading" type="primary" @click="submit">登录</el-button>
      </div> -->
    </el-form>
    <AiBottomIcp></AiBottomIcp>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import AiHead from '../components/AI-Head.vue'
  import AiBottomIcp from '../components/AI-Bottom-ICP'
  export default {
    name: 'Login',
    components: {
      AiHead,
      AiBottomIcp
    },
    data() {
      return {
        loading: false,
        userInfo: {
          userName: '',
          password: '',
          checked: false,
        },
      };
    },
    methods: {
      submit(){
        if (!this.userInfo.userName) {
          this.$message({message: '请输入用户名', type: 'warning'});
          return
        }
        if (!this.userInfo.password) {
          this.$message({message: '请输入密码', type: 'warning'});
          return
        }
        if (!this.userInfo.checked) {
          this.$message({message: '请阅读并同意《用户协议》和《隐私协议》', type: 'warning'});
          return
        }
        this.loading = true
        // 校验初始密码
        this.checkInitPwd()
      },
      // 校验初始密码
      checkInitPwd(){
        let data = { userName: this.userInfo.userName, password: this.userInfo.password }
        this.$http.post('/aigenai/checkInitPwd', data).then(
          res=>{
            if (res.code !== 0) {
              this.loading = false
              return
            }
            // 设置重置密码标志
            localStorage.setItem('reset', res.data)
            // 进入重置密码
            if (res.data) {
              this.$router.push({path:'/resetPassword', query:{userName: this.userInfo.userName}}) 
              return
            } 
            // 获取once值
            this.getOnce()
          }
        ).catch(err=>{console.log('err', err)})
      },
      // 获取once值
      getOnce(){
        this.$http.get('/aigenai/once').then(
          res=>{
            if (res.code !== 0 || !res.data) {
              this.loading = false 
              return
            }
            /* 登录： post请求的数据以对象的形式传输 */
            this.toLogin(res.data)
          }
        ).catch(err=>{console.log('err', err)})
      },
      // 登录
      toLogin(once){
        // 加盐
        let salt='aigenai-2023-!@#$qweRTYuioPASdfgHJKlzxCVBnm'
        //// 处理密码：md5加密
        let pwd = md5(md5(salt+this.userInfo.password) + once)
        this.$http.post('/aigenai/login',  {userName: this.userInfo.userName, password: pwd}).then(
          res=>{
            this.loading = false
            if (res.code !== 0) return
            // 进入主页
            this.$router.push({path:'/home'}, ()=>{})
            // 缓存用户id
            localStorage.setItem('userId', res.data.id)
            localStorage.setItem('userName', res.data.userName)
            // 将登录信息存到内存中
            let userInfo = {...res.data, logged: true}
            this.$store.commit('storeUserInfo', userInfo)
          }
        ).catch(err=>{console.log('err', err)})
      }
    },
  }
</script>

<style lang="less" scoped>
.login{
  position: absolute;
  display: flex;
  flex-direction: column;
  min-width: 320px;
  min-height: 300px;
  left:50%;
  /* top:35%; */
  /* 暂时改为50% */
  top: 50%;  
  margin-left:-150px;
  margin-top:-100px;
  &__prompt{
    text-align: center;
  }
  &__password{
    margin-top: 30px;
  }
  &__checkbox{
    margin-top: 40px;
    font-size: 12px;
  }
  &__button{
    margin-top: 10px;
  }
}
#el-button{
  width: 100%; 
  background-color: #0f62fe
}
</style>